import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import { Phases_getInstance1n7sbxr3lcpvf as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { isSuspendFunction153vlp5l2npj9 as isSuspendFunction } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  cancel1xim2hrvjmwpn as cancel,
  Key_instance2rlngjw9v1qsd as Key_instance,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPlugin16sdkdabbewya as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  return LOGGER;
}
var LOGGER;
function get_HttpRequestLifecycle() {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  return HttpRequestLifecycle;
}
var HttpRequestLifecycle;
var PipelineContext$proceed$refClass;
function PipelineContext$proceed$ref() {
  if (PipelineContext$proceed$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.a5s_1 = p0;
      }
      *w4k($completion) {
        yield* this.a5s_1.r4r($completion);
        return Unit_instance;
      }
      kd($completion) {
        return this.w4k($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    PipelineContext$proceed$refClass = $;
  }
  return PipelineContext$proceed$refClass;
}
function PipelineContext$proceed$ref_0(p0) {
  var i = new (PipelineContext$proceed$ref())(p0);
  var l = ($completion) => i.w4k($completion);
  l.$arity = 0;
  return l;
}
var SetupRequestContext$install$slambdaClass;
function SetupRequestContext$install$slambda() {
  if (SetupRequestContext$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.b5s_1 = $handler;
      }
      *z5g($this$intercept, it, $completion) {
        yield* this.b5s_1($this$intercept.o4s_1, PipelineContext$proceed$ref_0($this$intercept), $completion);
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.z5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    SetupRequestContext$install$slambdaClass = $;
  }
  return SetupRequestContext$install$slambdaClass;
}
function SetupRequestContext$install$slambda_0($handler) {
  var i = new (SetupRequestContext$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.z5g($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var SetupRequestContextClass;
function SetupRequestContext() {
  if (SetupRequestContextClass === VOID) {
    class $ {
      c5s(client, handler) {
        var tmp = Phases_getInstance().q5n_1;
        client.g5h_1.s4s(tmp, SetupRequestContext$install$slambda_0(handler));
      }
      v5n(client, handler) {
        return this.c5s(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SetupRequestContext');
    SetupRequestContextClass = $;
  }
  return SetupRequestContextClass;
}
var SetupRequestContext_instance;
function SetupRequestContext_getInstance() {
  return SetupRequestContext_instance;
}
function attachToClientEngineJob(requestJob, clientEngineJob) {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  var handler = clientEngineJob.vw((cause) => {
    if (!(cause == null)) {
      get_LOGGER().s4t('Cancelling request because engine Job failed with error: ' + cause.toString());
      cancel(requestJob, 'Engine failed', cause);
    } else {
      get_LOGGER().s4t('Cancelling request because engine Job completed');
      requestJob.k12();
    }
    return Unit_instance;
  });
  requestJob.vw((it) => {
    handler.jz();
    return Unit_instance;
  });
}
function HttpRequestLifecycle$lambda($this$createClientPlugin) {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  var tmp = SetupRequestContext_instance;
  $this$createClientPlugin.h5o(tmp, HttpRequestLifecycle$lambda$slambda_0($this$createClientPlugin));
  return Unit_instance;
}
var HttpRequestLifecycle$lambda$slambdaClass;
function HttpRequestLifecycle$lambda$slambda() {
  if (HttpRequestLifecycle$lambda$slambdaClass === VOID) {
    class $ {
      constructor($this_createClientPlugin) {
        this.d5s_1 = $this_createClientPlugin;
      }
      *e5s(request, proceed, $completion) {
        var executionContext = SupervisorJob(request.b5j_1);
        attachToClientEngineJob(executionContext, ensureNotNull(this.d5s_1.d5o_1.f5h_1.yc(Key_instance)));
        try {
          request.b5j_1 = executionContext;
          yield* proceed($completion);
        } catch ($p) {
          if ($p instanceof Error) {
            var cause = $p;
            executionContext.j12(cause);
            throw cause;
          } else {
            throw $p;
          }
        }
        finally {
          executionContext.k12();
        }
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof HttpRequestBuilder() ? p1 : THROW_CCE();
        return this.e5s(tmp, (!(p2 == null) ? isSuspendFunction(p2, 0) : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpRequestLifecycle$lambda$slambdaClass = $;
  }
  return HttpRequestLifecycle$lambda$slambdaClass;
}
function HttpRequestLifecycle$lambda$slambda_0($this_createClientPlugin) {
  var i = new (HttpRequestLifecycle$lambda$slambda())($this_createClientPlugin);
  var l = (request, proceed, $completion) => i.e5s(request, proceed, $completion);
  l.$arity = 2;
  return l;
}
var properties_initialized_HttpRequestLifecycle_kt_3hmcrf;
function _init_properties_HttpRequestLifecycle_kt__jgkmfx() {
  if (!properties_initialized_HttpRequestLifecycle_kt_3hmcrf) {
    properties_initialized_HttpRequestLifecycle_kt_3hmcrf = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestLifecycle');
    HttpRequestLifecycle = createClientPlugin('RequestLifecycle', HttpRequestLifecycle$lambda);
  }
}
//region block: init
SetupRequestContext_instance = new (SetupRequestContext())();
//endregion
//region block: exports
export {
  get_HttpRequestLifecycle as get_HttpRequestLifecycle1e7j0z243lnj5,
};
//endregion

//# sourceMappingURL=HttpRequestLifecycle.mjs.map
